// Íconos de Font Awesome (sin el prefijo "fa-") que se ofrecen al elegir el ícono de un
// reporte o de un custom link del menú. Solo nombres que existen en el Font Awesome 5.8 que
// carga public/index.html: uno que no exista se ve como un cuadro vacío.
export const AVAILABLE_ICONS = [
  "file-alt", "file", "folder", "folder-open", "chart-bar", "chart-line", 
  "chart-pie", "chart-area", "table", "list", "list-alt", "list-ul", "list-ol",
  "th", "th-list", "th-large", "clipboard", "clipboard-list", "clipboard-check",
  "tasks", "check-square", "calendar", "calendar-alt", "calendar-check",
  "clock", "history", "archive", "box", "boxes", "cube", "cubes",
  "database", "server", "hdd", "filter", "search", "eye", "eye-slash",
  "star", "star-half-alt", "heart", "bookmark", "flag", "tag", "tags",
  "user", "users", "user-friends", "user-tie", "user-cog", "user-check",
  "building", "home", "warehouse", "industry", "store", "store-alt",
  "dollar-sign", "euro-sign", "money-bill", "money-bill-alt", "coins", "wallet",
  "credit-card", "receipt", "file-invoice", "file-invoice-dollar",
  "shopping-cart", "cart-plus", "shopping-bag", "shopping-basket",
  "truck", "shipping-fast", "box-open", "dolly", "pallet",
  "globe", "globe-americas", "map", "map-marker", "map-marker-alt", "location-arrow",
  "plane", "ship", "anchor", "car", "bus", "train",
  "envelope", "envelope-open", "paper-plane", "inbox", "comment", "comments",
  "phone", "mobile-alt", "fax", "headset",
  "cog", "cogs", "wrench", "tools", "sliders-h", "toolbox",
  "bolt", "fire", "sun", "moon", "cloud", "umbrella",
  "bell", "bullhorn", "exclamation", "exclamation-circle", "info-circle",
  "question-circle", "check-circle", "times-circle", "plus-circle", "minus-circle",
  "lock", "unlock", "key", "shield-alt", "fingerprint",
  "pen", "pencil-alt", "edit", "eraser", "highlighter",
  "print", "file-pdf", "file-excel", "file-word", "file-image",
  "download", "upload", "cloud-download-alt", "cloud-upload-alt",
  "sync", "redo", "undo", "exchange-alt", "random",
  "sort", "sort-alpha-down", "sort-amount-down", "sort-numeric-down",
  "percentage", "calculator", "balance-scale", "weight",
  "barcode", "qrcode", "hashtag", "at", "link",
  "expand", "compress", "arrows-alt", "external-link-alt",
  "share", "share-alt", "reply", "forward",
  "play", "pause", "stop", "step-forward", "step-backward",
  "volume-up", "volume-down", "volume-mute", "music",
  "image", "images", "camera", "video", "film",
  "magic", "lightbulb", "brain", "robot",
  "graduation-cap", "book", "book-open", "newspaper"
];
